"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _spinner = _interopRequireDefault(require("./spinner.svg"));

/**
 * @deprecated: Please use the spinner from the pf-component-library.
 */
const Spinner = function ({
  show
}) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "spinner",
    style: {
      display: show ? 'block' : 'none'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "spinner__mask"
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: _spinner.default,
    alt: "a loading spinner",
    className: "spinner__logo"
  }));
};

Spinner.propTypes = {
  show: _propTypes.bool
};
Spinner.defaultProps = {
  show: false
};
var _default = Spinner;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/shared-components/lib/components/Spinner/Spinner.scss');